/* eslint-disable max-len */
const zhCn = {
  CancellationRequest: '请求取消',
  Heading: '请提供以下信息。所有栏均需填写。',
  Note: '需要取消您的预订？我们随时为您提供协助。在以下各栏填写您要取消的预订。',
  PartnerNote:
    '谢谢！我们将优先处理旅行日期最近的请求。如果我们没有在您的旅行日期之前确认您的取消，请知悉，我们正在处理。您不需要做任何事情。',
  SubmitNote:
    '由于出现大量旅行中断的情况，处理退款可能会有所延迟。为此导致您的长时间等待，我们深表歉意，并感谢您的耐心配合。',
  Disclaimer: '重要信息：该表格仅用于 2021 年 12 月 31 日及之前的旅行日期。',
  Itin: '行程编号（您的行程单或确认邮件中的 11 - 15 位编号）',
  EmailAddress: '用于该预订的电子邮件地址',
  PhoneNumber: '用于该预订的电话号码',
  Reason: '原因',
  Submit: '继续',
  Success: '我们已收到您的请求',
  Failed: '非常抱歉',
  InProgress: '我们正在努力解决',
  TryAgain: '返回',
  PhoneErrorMessage: '请输入有效的电话号码。',
  EmailErrorMessage: '请输入有效的邮箱地址',
  ItinErrorMessage: '请输入有效的行程编号',
  ResponseEligibleHeader: '我们已找到您的行程',
  ResponseEligibleSubmit: '是，取消我的预订',
  ResponseEligibleNeverMind: '否，不取消',
  ResponseOnlyLodgingWithRefund:
    '您有 {x} 个住宿预订符合退款条件。如果您选择取消，将会通过原付款方式收到退款。',
  ResponseOnlyLodgingWithCoupon:
    '您有 {x} 个住宿预订符合以优惠券形式领取兑换券的条件。如果您选择取消，我们将向您发放一张金额等于原购买价格的优惠券。',
  ResponseOnlyLodgingInEligible:
    '您有 {x} 个住宿预订不符合免费取消的条件。如果您选择取消，需遵守住宿合作伙伴的标准取消政策。',
  ResponseLodgingWithOtherLob:
    '对于该行程的所有其他预订，需遵守旅行合作伙伴的政策。',
  ResponseNoLodgingWithOtherLob:
    '对于该行程的所有预订，需遵守旅行合作伙伴的政策。',
  ResponseAlreadyCancelled:
    '您有 {x} 个住宿预订已被取消。由于出现大量旅行中断的情况，处理退款可能会有所延迟。如有任何问题，请致电我们的客户支持团队。',
  ResponseNoFlexAvailable:
    '您有 {x} 个住宿预订不符合退款或兑换券的条件。如果您现在取消，则需遵守住宿合作伙伴的标准取消政策。但取消政策有可能有变化。请在行程开始之前 8 天时再来查看最新的取消政策。',
  ResponseInvalidDuplicateItinerary:
    '您似乎已经提交了该请求。我们将优先处理旅行日期最近的请求。如果我们没有在您的旅行日期之前确认您的取消，请知悉，我们正在处理。您不需要做任何事情。',
  ResponseElligibleConfirmation: '您想要取消您的预订吗？',
  ResponseInvalidUnknown:
    '我们找不到该行程或确认编号。请检查编号，然后再试一次。您预订之后曾收到我们发送的电子邮件，您可以从中找到该编号。',
  ResponseInvalidItineraryNotFound:
    '我们找不到该行程或确认编号。请检查编号，然后再试一次。您预订之后曾收到我们发送的电子邮件，您可以从中找到该编号。',
  ResponseInvalidTripMoreThanSevenDays: '我们无法处理您的请求。',
  ResponseInvalidTripIsLcc:
    '您的航空公司处理所有取消请求。请直接与航空公司联系。有关更多信息，请登录您的帐户并查看您的在线行程。目前正在处理的取消操作最多可能需要 72 小时才能在您的行程中显示为已取消。',
  ResponseInvalidTripIsTicketless:
    '您的航空公司处理所有取消请求。请直接与航空公司联系。有关更多信息，请登录您的帐户并查看您的在线行程。目前正在处理的取消操作最多可能需要 72 小时才能在您的行程中显示为已取消。',
  ResponseInvalidItinerary: '我们无法识别该行程编号。请再试一次。',
  ResponseInvalidStatus: '出错了。请再试一次。',
  ResponseInvalidEmail:
    '我们无法识别该电子邮件地址，或者该电子邮件地址与该行程所用的不匹配。请确保这是您在预订时使用的电子邮件地址。',
  ResponseInvalidPhone:
    '我们无法识别该电话号码。请确保这是您在预订时使用的电话号码。',
  ResponseTripHasLccFlight:
    '我们可以取消您的部分预订，但不能全部取消。对于我们无法取消的预订，请直接联系供应商。您可以使用您的在线行程来确定还需要取消哪些预订。目前正在处理的取消操作最多可能需要 72 小时才能在您的行程中显示为已取消。',
  ResponseErrorTripWithin24Hrs:
    '很抱歉，由于您取消的时间距离旅行日期不到 24 小时，我们无法处理您的请求。有关更多信息，请登录您的帐户并查看您的在线行程。',
  ResponseInvalidTripInCruise:
    '我们无法通过该表格接受游轮取消请求。请登录您的帐户，然后从您的行程中在线取消。',
};

export default zhCn;
